<div class="container">
  <div class="row">
    <div class="col-12">
      <h2 class="text-center mb-5">Welcome</h2>

      <app-login-form *ngIf="!mfaRequired" (submitEvent)="login($event)"></app-login-form>

      <!-- Second factor: shown only when the account has MFA enabled. -->
      <div *ngIf="mfaRequired" class="mfa-step text-center">
        <p class="mfa-title">Two-factor verification</p>
        <p class="mfa-sub">
          Enter the 6-digit code from your authenticator app — or, if you lost
          your phone, one of your recovery codes.
        </p>
        <!-- maxlength 11 fits both a 6-digit TOTP and an XXXXX-XXXXX recovery code. -->
        <input
          #totpInput
          type="text"
          autocomplete="one-time-code"
          maxlength="11"
          placeholder="123456"
          class="mfa-input"
          (keyup.enter)="submitTotp(totpInput.value)"
        />
        <div *ngIf="mfaError" class="mfa-err">{{ mfaError }}</div>
        <button type="button" class="mfa-btn" (click)="submitTotp(totpInput.value)">Verify</button>
      </div>

      <!-- Single sign-on is offered only where the server holds credentials
           for it; otherwise the whole block is absent rather than showing a
           button that can only fail. -->
      <ng-container *ngIf="!mfaRequired && (googleEnabled || epicEnabled)">
        <div class="text-center my-3" style="color:#888; font-size:13px;">— or —</div>
        <div class="d-flex justify-content-center" *ngIf="googleEnabled">
          <div #googleBtn></div>
        </div>
        <div class="d-flex justify-content-center mt-2" *ngIf="epicEnabled">
          <button type="button" class="epic-login-btn" (click)="loginWithEpic()">
            <span class="epic-mark">✚</span> Login with Epic
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

